import { render } from "./MusicComponent.vue?vue&type=template&id=4a08fd9b&scoped=true"
import script from "./MusicComponent.vue?vue&type=script&lang=js"
export * from "./MusicComponent.vue?vue&type=script&lang=js"

import "./MusicComponent.vue?vue&type=style&index=0&id=4a08fd9b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a08fd9b"]])

export default __exports__